import { withInstall } from '@ll-plus/utils'

import Checkbox from './src/checkbox.vue'
import CheckboxGroup from './src/checkbox-group.vue'

export const LlCheckbox = withInstall(Checkbox)
export const LlCheckboxGroup = withInstall(CheckboxGroup)

export * from './src/checkbox'

declare module 'vue' {
  export interface GlobalComponents {
    LlCheckbox: typeof Checkbox
    LlCheckboxGroup: typeof CheckboxGroup
  }
}
